import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface DerBUCHBUTLERState extends BasePageState {}
interface DerBUCHBUTLERModel {}

export default class DerBUCHBUTLERPage extends Basepage<
  DerBUCHBUTLERState,
  DerBUCHBUTLERModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="DerBUCHBUTLER">
        Wer ist der BUCHBUTLER?
        <br />
        <br />
        Der BUCHBUTLER ist nicht nur einfach ein Shop für Buchhändler und
        <br />
        Firmenkunden, sondern ein Lösungsanbieter.
        <br />
        Er will Ihnen helfen. Er kann Ihnen helfen!
        <br />
        <br />
        Sie wollen Bücher in Ihren Shop oder Ihre Warenwirtschaft integrieren?{' '}
        <br />
        Er programmiert Ihnen passende Schnittstellen, um sich an Ihr System
        <br />
        anzudocken.
        <br />
        <br />
        Sie wollen passend zu Ihrem Thema und bestehendem Sortiment, Ihren
        <br />
        Kund*innen Bücher empfehlen und verkaufen?
        <br />
        Haben aber Angst vor der Datenflut aus 12 Millionen Büchern?
        <br />
        Denn in Ihren Sportshop sollen ausschließlich Sportbücher, In Ihren
        <br />
        Reiseshop Reiseführer, in Ihren exquisiten Möbelshop
        Einrichtungsratgeber
        <br />
        und hochwertige Bildbände?
        <br />
        Der BUCHBUTLER selektiert für Sie die passenden Buchdaten und liefert
        Ihnen
        <br />
        maßgeschneiderte Exporte, damit Sie Ihr Sortiment bequem erweitern
        können.
        <br />
        <br />
        Sie wollen für Ihren Verlag einen Shop, sodass Ihre Kund*innen durch all
        <br />
        Ihre Verlagsbücher stöbern können?
        <br />
        Der BUCHBUTLER baut Ihnen einen Shop.
        <br />
        <br />
        Der BUCHBUTLER liefert Ihnen passende Lösungen, Exporte, Daten.
        <br />
      </div>
    );
  }
  initState(base: BasePageState): DerBUCHBUTLERState {
    let newState: DerBUCHBUTLERState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Der BUCHBUTLER';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Werbung: Exporte</span>;
  }
  getType(): string {
    return 'DerBUCHBUTLER';
  }
}
